import { render, staticRenderFns } from "./couponRules.vue?vue&type=template&id=103cdc26&scoped=true"
import script from "./couponRules.vue?vue&type=script&lang=js"
export * from "./couponRules.vue?vue&type=script&lang=js"
import style0 from "./couponRules.vue?vue&type=style&index=0&id=103cdc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103cdc26",
  null
  
)

export default component.exports